// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"49":"149610ab","147":"73b25657","164":"45a729ea","186":"3a5cfa87"}[chunkId] + ".css";
};